// Shared so ComposeStepUI (compose modal) and MicropostItem (list display)
// can't drift on the flag name.
//
// ConfigCat release flag (default off) gating the season-scoped audience UI
// added for micropost seasonality (AB#19976): the season picker in the
// compose modal, and the season-aware audience label + tooltip on each list
// item. The backend SeasonID plumbing ships unconditionally — this flag
// hides only the new front-end surface until the companion Pendo walkthrough
// is ready.
export const SEASONALITY_FLAG = 'enable-seasonality'
